import React, { useState } from 'react'
import RechargePromotionsHistory from '../components/RechargePromotionsHistory/RechargePromotionsHistory'

const RechargePromotionsHistoryPage = () => {
  return (
    <>
      <RechargePromotionsHistory />
    </>
  )
}

export default RechargePromotionsHistoryPage
